import { Locale } from '~i18n/i18nConfig';

type BaseContacts = {
    phones: string[];
    salesEmail: string;
};

type OptionalContacts = {
    whatsapp: string;
    pec: string;
};

type ItContacts = BaseContacts & OptionalContacts;

type OtherContacts = BaseContacts & Partial<OptionalContacts>;

type LocaleContacts = { [Locale.IT]: ItContacts } & { [K in Exclude<Locale, Locale.IT>]: OtherContacts };

type UseFleequidContactsReturn = {
    phones: ComputedRef<string[]>;
    whatsapp: ComputedRef<string>;
    salesEmail: ComputedRef<string>;
    pec: ComputedRef<string | undefined>;
};

export const LOCALE_CONTACTS: LocaleContacts = {
    [Locale.CS]: { phones: ['+420 228 887 226'], salesEmail: 'prodej@fleequid.com' },
    [Locale.DE]: { phones: ['+49 1522 486 7474', '+43 1 4351920'], whatsapp: '+49 1522 4872022', salesEmail: 'vertrieb@fleequid.com' },
    [Locale.EN]: { phones: ['+39 0287176063'], salesEmail: 'sales@fleequid.com' },
    [Locale.ES]: { phones: ['+34 815 01 00 78'], salesEmail: 'ventas@fleequid.com' },
    [Locale.FR]: { phones: ['+39 0287176063'], salesEmail: 'ventes@fleequid.com' },
    [Locale.IT]: { phones: ['+39 0287176063'], whatsapp: '+39 0287176063', salesEmail: 'vendite@fleequid.com', pec: 'adorea@pecaruba.it' },
    [Locale.NL]: { phones: ['+32 2 808 78 26'], salesEmail: 'verkoop@fleequid.com' },
    [Locale.PL]: { phones: ['+48 22 397 06 04'], salesEmail: 'sprzedaz@fleequid.com' },
    [Locale.PT]: { phones: ['+351 308 811 471'], salesEmail: 'vendas@fleequid.com' },
    [Locale.RO]: { phones: ['+39 0287176063'], salesEmail: 'sales@fleequid.com' },
    [Locale.RU]: { phones: ['+39 0287176063'], salesEmail: 'sales@fleequid.com' },
};

export default (): UseFleequidContactsReturn => {
    const { locale } = useTypedI18n();

    const phones = computed(() => LOCALE_CONTACTS[locale.value].phones);

    const whatsapp = computed(() => LOCALE_CONTACTS[locale.value].whatsapp ?? LOCALE_CONTACTS[Locale.IT].whatsapp);

    const salesEmail = computed(() => LOCALE_CONTACTS[locale.value].salesEmail);

    const pec = computed(() => LOCALE_CONTACTS[locale.value].pec);

    return { phones, whatsapp, salesEmail, pec };
};
